import { render, staticRenderFns } from "./scanQr.vue?vue&type=template&id=2b11baa0&scoped=true"
import script from "./scanQr.vue?vue&type=script&lang=js"
export * from "./scanQr.vue?vue&type=script&lang=js"
import style0 from "./scanQr.vue?vue&type=style&index=0&id=2b11baa0&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2b11baa0",
  null
  
)

export default component.exports